import React from "react";
import ReactWordcloud from "react-wordcloud";
import { ResponsiveContainer } from "recharts";

import * as Colors from "../Colors";

import "tippy.js/dist/tippy.css";
import "tippy.js/animations/scale.css";

const COLORS = Colors.COLORS_9;

export default function Cloud({ data, options }) {
  data = data ?? [];

  const fontSizes = options.fontSizes ? options.fontSizes : [15, 60];
  const scale = options.scale ? options.scale : "log";

  const params = {
    colors: COLORS,
    enableTooltip: true,
    deterministic: true,
    fontFamily: "Poppins",
    fontSizes: fontSizes,
    padding: 1,
    rotations: 2,
    rotationAngles: [0, 0],
    scale: scale,
    textAttributes: {
      style: "outline: none;",
    },
  };

  return (
    <ResponsiveContainer width="100%" height="100%">
      <ReactWordcloud words={data} options={params} />
    </ResponsiveContainer>
  );
}
